export enum FilterType {
    LT,
    EQ,
    GT,
    LTE,
    GTE,
  }